import { onRequest, RequestMethod } from "../common/axios/axios"
import { getApiUrl } from "../common/axios/getApiUrl"

export interface FaqParams {
    serviceId: string
    locale: string
    faqType: string
    searchName?: string
    pageNo: number
    pageSize: number
}

export class FaqRepository {
    static onGetFaqList = (params: FaqParams) => {
        return onRequest({url: getApiUrl('faq-list'), method: RequestMethod.POST, params})
    }
    static onGetFaqDetail = (faqNo: number, serviceId: String) => {
        return onRequest({url: getApiUrl('faq-detail')+`/${faqNo}?serviceId=${serviceId}`, method: RequestMethod.GET, });
    }
}
